"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SocketRPC = exports.RpcEvent = exports.RpcCallable = void 0;
var rxjs_1 = require("rxjs");
var uuid_1 = require("uuid");
function isRequest(message) {
    return message.type === 'request';
}
function isResponse(message) {
    return message.type === 'response';
}
function isEvent(message) {
    return message.type === 'event';
}
function RpcCallable() {
    return function (target, propertyKey) {
        Reflect.defineMetadata('rpc:type', 'call', target, propertyKey);
    };
}
exports.RpcCallable = RpcCallable;
function RpcEvent() {
    return function (target, propertyKey) {
        Reflect.defineMetadata('rpc:type', 'event', target, propertyKey);
    };
}
exports.RpcEvent = RpcEvent;
var SocketRPC = /** @class */ (function () {
    function SocketRPC() {
        this._requestMap = new Map();
        this._eventMap = new Map();
        var self = this;
        this._peer = new Proxy({}, {
            get: function (target, methodName, receiver) {
                return function () {
                    var parameters = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        parameters[_i] = arguments[_i];
                    }
                    return self.call.apply(self, __spreadArray([String(methodName)], parameters, false));
                };
            }
        });
    }
    SocketRPC.prototype.bind = function (socket) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                if (this._socket)
                    throw new Error("Already bound");
                this._socket = socket;
                this._socket.onmessage = function (ev) { return _this.onReceiveMessage(JSON.parse(ev.data)); };
                return [2 /*return*/, this];
            });
        });
    };
    Object.defineProperty(SocketRPC.prototype, "peer", {
        get: function () { return this._peer; },
        enumerable: false,
        configurable: true
    });
    SocketRPC.prototype.getEventInternal = function (name) {
        if (!this._eventMap.has(name)) {
            this._eventMap.set(name, new rxjs_1.Subject());
        }
        return this._eventMap.get(name);
    };
    SocketRPC.prototype.rawSend = function (message) {
        this._socket.send(JSON.stringify(message));
    };
    SocketRPC.prototype.sendEvent = function (name, object) {
        this.rawSend({ type: 'event', name: name, object: object });
    };
    SocketRPC.prototype.call = function (method) {
        var _this = this;
        var parameters = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            parameters[_i - 1] = arguments[_i];
        }
        var rpcRequest = {
            type: 'request',
            id: (0, uuid_1.v4)(),
            method: method,
            parameters: parameters
        };
        return new Promise(function (resolve, reject) {
            _this._requestMap.set(rpcRequest.id, function (response) {
                if (response.error)
                    reject(response.error);
                else
                    resolve(response.value);
            });
            _this.rawSend(rpcRequest);
        });
    };
    SocketRPC.prototype.onReceiveMessage = function (message) {
        return __awaiter(this, void 0, void 0, function () {
            var value, error, e_1, handler;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!isRequest(message)) return [3 /*break*/, 7];
                        if (!(this.getRpcType(message.method) === 'call' && typeof this[message.method] === 'function')) return [3 /*break*/, 5];
                        value = void 0;
                        error = void 0;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this[message.method].apply(this, message.parameters)];
                    case 2:
                        value = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        if (e_1 instanceof Error) {
                            error = { message: e_1.message, stack: e_1.stack };
                        }
                        else {
                            error = e_1;
                        }
                        return [3 /*break*/, 4];
                    case 4:
                        this.rawSend({
                            type: 'response',
                            id: message.id,
                            value: value,
                            error: error
                        });
                        return [2 /*return*/];
                    case 5:
                        this.rawSend({
                            type: 'response',
                            id: message.id,
                            error: { code: 'invalid-call', message: "No such method '".concat(message.method, "'") }
                        });
                        _a.label = 6;
                    case 6: return [2 /*return*/];
                    case 7:
                        if (isResponse(message)) {
                            handler = this._requestMap.get(message.id);
                            if (!handler) {
                                console.error("Received response to unknown request '".concat(message.id, "'"));
                                return [2 /*return*/];
                            }
                            this._requestMap.delete(message.id);
                            handler(message);
                            return [2 /*return*/];
                        }
                        if (isEvent(message)) {
                            if (this.getRpcType(message.name) === 'event') {
                                this[message.name](message.object);
                                return [2 /*return*/];
                            }
                            else {
                                console.error("Unsupported event type '".concat(message.name, "' received."));
                                return [2 /*return*/];
                            }
                        }
                        if (message.type === 'ping') {
                            this.rawSend({ type: 'pong' });
                            return [2 /*return*/];
                        }
                        console.error("Unknown message type from server '".concat(message.type, "'"));
                        return [2 /*return*/];
                }
            });
        });
    };
    SocketRPC.prototype.getRpcType = function (name) {
        return Reflect.getMetadata('rpc:type', this.constructor.prototype, name) || 'none';
    };
    SocketRPC.prototype.close = function () {
        this._socket.close();
    };
    return SocketRPC;
}());
exports.SocketRPC = SocketRPC;
